import * as React from "react";

export type FieldLabelRightProps = React.HTMLAttributes<HTMLDivElement>;

export const FieldLabelRight = React.forwardRef<HTMLDivElement, FieldLabelRightProps>(
  ({ children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        data-field-label-right=""
        {...rest}
        style={{ marginLeft: "auto", display: "inline-flex", ...rest.style }}
      >
        {children}
      </div>
    );
  }
);

FieldLabelRight.displayName = "FieldLabelRight";
